import axios from "axios";
import { Button, Form, Popup } from "devextreme-react";
import {
  ButtonItem,
  EmailRule,
  Label,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { notifyMsg } from "../common/notify";

// import * as sigIcon from "./signature-solid.svg";

import logoHImg from "../EquipmentManagement/hBeccoCRO.png";

export default function SignatureItem(props) {
  const [signaturePopupVisible, setSignaturePopupVisible] = useState(false);

  const formRef = useRef(null);

  const {
    gridRef,
    tpId,
    isTrainer,
    sig,
    /*trainer*/ sigEmployeeNo,
    noSig,
    setTrainingAttendanceListSignaturePopupVisible,
  } = props;

  const employeeNo = useSelector((state) => state.userInfo.employeeNo);

  // useEffect(() => {
  //   console.debug(
  //     "gridDataSource",
  //     gridRef.current.instance.getDataSource().items()
  //   );

  //   if (isTrainer) {
  //     const traineeList = gridRef.current.instance.getDataSource().items();

  //     const noSig = traineeList.find((trainee) => trainee.sig == null);

  //     console.debug("noSig", noSig);

  //     if (noSig) {
  //       setNoSig(true);
  //     }
  //   }
  // }, []);

  const onClick = () => {
    if (isTrainer) {
      if (noSig) {
        notifyMsg("서명하지 않은 학습자가 있습니다.", "warning");
      } else {
        setSignaturePopupVisible(true);
      }
    } else {
      setSignaturePopupVisible(true);
    }
  };

  const onHiding = () => {
    setSignaturePopupVisible(false);
  };

  const onClickSignature = () => {
    const formData = formRef.current.instance.option("formData");

    axios
      .post(`${process.env.REACT_APP_BECCO_API_URL}/api/common/login`, formData)
      .then((result) => {
        if (result.data.code === 200) {
          if (isTrainer) {
            axios
              .put(
                `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tp/sig/trainer/${tpId}`
              )
              .then((result) => {
                notifyMsg("서명이 완료되었습니다.", "success");

                gridRef.current.instance.getDataSource().reload();
                setTrainingAttendanceListSignaturePopupVisible(false);
              });
          } else {
            axios
              .put(
                `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trRec/sig/${tpId}`,
                {
                  trainee: employeeNo,
                }
              )
              .then((result) => {
                notifyMsg("서명이 완료되었습니다.", "success");

                gridRef.current.instance.getDataSource().reload();
                setTrainingAttendanceListSignaturePopupVisible(false);
              });
          }
        } else {
          notifyMsg("아이디 또는 비밀번호가 일치하지 않습니다.", "error");
        }
      });

    setSignaturePopupVisible(false);
  };

  const getDate = (sig) => {
    const date = new Date(sig);

    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")}`;
  };

  const getTime = (sig) => {
    const date = new Date(sig);

    return `T${String(date.getHours()).padStart(2, "0")}:${String(
      date.getMinutes()
    ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
  };

  return (
    <React.Fragment>
      <div>
        {isTrainer && (
          <Button
            text={
              sig
                ? `Trainer Sig. ${getDate(sig)}${getTime(sig)}`
                : "Trainer Sig."
            }
            stylingMode="contained"
            type={noSig ? "danger" : "success"}
            width={450}
            onClick={onClick}
            disabled={sigEmployeeNo == employeeNo ? (sig ? true : false) : true}
          />
        )}
        {!isTrainer && !sig && (
          <Button
            icon={"check"}
            style={{
              marginTop: "0px",
              marginBottom: "0px",
              marginRight: "30px",
              paddingTop: "0px",
              paddingBottom: "0px",
              backgroundColor: sig ? "white" : "rgba(244, 67, 54, 0.32)",
            }}
            onClick={onClick}
            // disabled={sigEmployeeNo == employeeNo ? false : true}
            disabled={sig ? true : sigEmployeeNo == employeeNo ? false : true}
          />
          // <a
          //   href="#"
          //   className="dx-link dx-icon-check dx-link-icon"
          //   title="Signature"
          //   aria-label="Signature"
          //   // style={{
          //   //   backgroundColor:
          //   //     traineeSig > 0 || trainerSig == null
          //   //       ? "rgba(244, 67, 54, 0.32)"
          //   //       : "transparent",
          //   // }}
          // ></a>
        )}
        {!isTrainer && sig && (
          <div style={{ fontSize: "11px" }}>
            <div>
              {getDate(sig)}
              {getTime(sig)}
            </div>
            {/* <div>{getTime(sig)}</div> */}
          </div>
        )}

        <Popup
          visible={signaturePopupVisible}
          onHiding={onHiding}
          dragEnabled={false}
          hideOnOutsideClick={true}
          showCloseButton={true}
          width={400}
          height={350}
          title="Signature"
        >
          <img
            src={logoHImg}
            width={170}
            height={60}
            style={{ margin: "0 auto", display: "block" }}
          />
          <Form
            id="form-signature"
            ref={formRef}
            labelMode="outside"
            showColonAfterLabel={false}
            labelLocation={"top"}
            validationGroup="signature"
          >
            <SimpleItem dataField={"email"} editorType={"dxTextBox"}>
              <Label text="이메일" />
              <RequiredRule message={"Email is required"} />
              <EmailRule message={"Email is invalid"} />
            </SimpleItem>
            <SimpleItem
              dataField={"password"}
              editorType="dxTextBox"
              editorOptions={{
                mode: "password",
                // onEnterKey
              }}
            >
              <Label text={"비밀번호"} />
              <RequiredRule message={"Password is required"} />
            </SimpleItem>
            <ButtonItem
              horizontalAlignment={"center"}
              verticalAlignment={"bottom"}
              buttonOptions={{
                text: "서명",
                type: "success",
                width: "100%",
                onClick: onClickSignature,
              }}
            />
            <div
              style={{
                textAlign: "center",
                marginTop: "10px",
                color: "rgba(0,0,0,.6)",
              }}
            >
              &copy; BeccoCRO Inc.
            </div>
          </Form>
        </Popup>
      </div>
    </React.Fragment>
  );
}
